import {
  faBold,
  faRedo,
  faUnderline,
  faItalic,
  faUndo,
  faHeading,
  faListOl,
  faListUl,
  faImage,
  faLink,
  faAlignLeft,
  faAlignCenter,
  faAlignRight
} from '@fortawesome/free-solid-svg-icons'

export const extensionsConfiguration = {
  bold: {
    inMenu: true,
    commands: [{ actionName: 'toggleBold', namespace: 'bold', icon: faBold }]
  },
  heading: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        icon: faHeading,
        text: '1',
        options: { level: 1 }
      },
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        icon: faHeading,
        text: '2',
        options: { level: 2 }
      },
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        icon: faHeading,
        text: '3',
        options: { level: 3 }
      }
    ]
  },
  bulletList: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleBulletList',
        namespace: 'bulletList',
        icon: faListUl
      }
    ]
  },
  orderedList: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleOrderedList',
        namespace: 'orderedList',
        icon: faListOl
      }
    ]
  },
  listItem: {
    inMenu: false
  },
  underline: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleUnderline',
        namespace: 'underline',
        icon: faUnderline
      }
    ]
  },
  italic: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleItalic',
        namespace: 'italic',
        icon: faItalic
      }
    ]
  },
  placeholder: {
    inMenu: false
  },
  history: {
    inMenu: true,
    commands: [
      { actionName: 'undo', namespace: 'history', icon: faUndo },
      { actionName: 'redo', namespace: 'history', icon: faRedo }
    ]
  },
  image: {
    HTMLAttributes: {
      class: 'd-block'
    },
    inMenu: true,
    commands: [
      {
        actionName: 'setImage',
        namespace: 'image',
        icon: faImage
      }
    ]
  },
  link: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleLink',
        namespace: 'link',
        icon: faLink
      }
    ]
  },
  textAlign: {
    inMenu: true,
    commands: [
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: faAlignLeft,
        options: 'left'
      },
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: faAlignCenter,
        options: 'center'
      },
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: faAlignRight,
        options: 'right'
      }
    ]
  }
}
